import { useRouter } from 'vue-router';
import { gsap, prefersReducedMotion } from '@/plugins/gsap';

// Height of the sticky header, so anchored scrolls don't land under it.
const headerOffset = () => {
  const header = document.querySelector('header.header--global');
  return header ? header.offsetHeight : 0;
};

// GSAP smooth scroll. `target` is a number (px), a selector or an element.
export function smoothScrollTo(target = 0, { duration = 0.6, offset } = {}) {
  const y = target;
  const offsetY = offset === undefined ? (typeof target === 'number' ? 0 : headerOffset()) : offset;
  if (prefersReducedMotion()) {
    gsap.set(window, { scrollTo: { y, offsetY } });
    return;
  }
  gsap.to(window, {
    duration,
    ease: 'power2.out',
    overwrite: 'auto',
    scrollTo: { y, offsetY, autoKill: true },
  });
}

export const smoothScrollToTop = () => smoothScrollTo(0);

// Router navigation followed by a smooth scroll to the top of the new page,
// the same behaviour as the legacy DesktopMenu.navigateTo, but driven by GSAP.
export function useSmoothNavigate() {
  const router = useRouter();
  return (path) => {
    if (!path) return Promise.resolve();
    return router
      .push(path)
      .then(() => smoothScrollToTop())
      .catch((err) => {
        if (err && err.name !== 'NavigationDuplicated') console.error('Navigation error:', err);
      });
  };
}
